
<div v-if="visibleCareServices.length > 0" class="care-services-container">
  <div class="care-services-grid">
    <CareTypeCard
      v-for="careType in visibleCareServices"
      :key="careType"
      :careType="careType"
      :showArrow="false"
      :selected="false"
      :style="{ '--dynamic-clickable-hover': '1' }"
      @click="navigateToCareTypeProfile"
    />
  </div>
</div>
